import { render, staticRenderFns } from "./ebt_balance.vue?vue&type=template&id=3d5cac2c&"
import script from "./ebt_balance.vue?vue&type=script&lang=js&"
export * from "./ebt_balance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports